import { render, staticRenderFns } from "./HonjoTabs.vue?vue&type=template&id=f4d0e40c"
import script from "./HonjoTabs.vue?vue&type=script&lang=ts"
export * from "./HonjoTabs.vue?vue&type=script&lang=ts"
import style0 from "./HonjoTabs.vue?vue&type=style&index=0&id=f4d0e40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports